<div [attr.aria-describedby]="describedBy" [attr.aria-labelledby]="parentFormField.getLabelId()">
  <ng-container *ngIf="loaded$ | async; else spinner">
    <input 
      matInput
      [formControl]="control"
      [placeholder]="placeholder"
      (focus)="onFocusIn($event)"
      (blur)="onFocusOut($event)"
      [required]="required"
      [matAutocomplete]="autocomplete"
    />
    <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayMemberFn()" (optionSelected)="optionSelected($event)">
      <mat-option *ngFor="let item of filtered" [value]="valueMemberFn(item)"
        style="min-height: 48px; line-height: normal; height: auto; padding: 10px 20px;">
        <div>{{ getDisplayMember(item) }}</div>
        <div *ngIf="secondLineMember"><small>{{ getSecondLineMember(item) }}</small></div>
      </mat-option>
    </mat-autocomplete>
  </ng-container>
  <ng-template #spinner>
    <div fxLayoutAlign="flex-end center" class="spinner">
      <mat-spinner diameter="15"></mat-spinner>
    </div>
  </ng-template>
</div>